const KEY = "frontrow.pendingFamilyInvitation";
const MAX_AGE = 7 * 24 * 60 * 60 * 1000;

export function rememberFamilyInvitation(token) {
  if (!/^[A-Za-z0-9_-]{20,200}$/.test(token || "")) return;
  try {
    window.sessionStorage.setItem(KEY, JSON.stringify({ token, savedAt: Date.now() }));
  } catch { /* The original email link remains usable if storage is unavailable. */ }
}

export function clearFamilyInvitation() {
  try { window.sessionStorage.removeItem(KEY); } catch { /* no stored invitation */ }
}

export function pendingFamilyInvitation() {
  try {
    const stored = JSON.parse(window.sessionStorage.getItem(KEY));
    if (stored && /^[A-Za-z0-9_-]{20,200}$/.test(stored.token || "") &&
        Number.isFinite(stored.savedAt) && Date.now() - stored.savedAt <= MAX_AGE) {
      return stored.token;
    }
  } catch { /* malformed or unavailable session storage */ }
  clearFamilyInvitation();
  return "";
}
